import { Box } from '@mui/material';
import React from 'react'

const DamagedProducts = () => {
  return (
    <Box>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>
      <h1>ksjajdbjkabsdfkjjbsdjkf</h1>

    </Box>
  )
}

export default DamagedProducts;
